import { render, staticRenderFns } from "./barClock.vue?vue&type=template&id=6e453a5e&scoped=true"
import script from "./barClock.vue?vue&type=script&lang=js"
export * from "./barClock.vue?vue&type=script&lang=js"
import style0 from "./barClock.vue?vue&type=style&index=0&id=6e453a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e453a5e",
  null
  
)

export default component.exports